
import axios from '@/axios.js'

export default {

  getUserTrainings({ state }) {
    if (state.userTrainings.length > 0) return
    return new Promise((resolve, reject) => {
      axios.get('/trainings')
        .then((response) => {
          // commit('ADD_USER_TRAININGS', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getUserTraining({state}, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`/trainings/${uuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  startTraining ({commit, state}, uuid) {
    return new Promise((resolve, reject) => {
      axios.post (`/trainings/${uuid}`)
        .then((response) => {
          commit('START_TRAINING', uuid)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  downloadCert ({state}, uuid ) {
    return new Promise((resolve, reject) => {
      const url = `/trainings/${uuid}/cert`
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
